module.exports = __webpack_public_path__ + "media/images/ico-share-68066fac.svg";